import styled from 'styled-components';

export default styled.div`
    width: ${props => props.width || '95%'};
    border: 1px solid ${props => props.color || 'rgba(0,0,0,0.25)'};
    margin-top: ${props => props.marginTop || '16px'};
    margin-bottom: ${props => props.marginBottom || '16px'};
`;